module.exports = __webpack_public_path__ + "img/hide.35c4119e.svg";